<template>
  <div>
    <div class="d-flex justify-content-between">
      <h1 class="page-header">
        {{ $t('studentScoringComponentEntry.pageTitle') }}
      </h1>
      <ts-breadcrumb
        :items="[
          { text: $t('toHomePage'), href: '/' },
          {
            text: $t('studentScoringComponentEntry.pageTitle'),
            active: true,
          },
        ]"
      />
    </div>
    <ts-card>
      <ts-card-wrapper>
        <div class="d-flex justify-content-between">
          <ts-button
            outline
            color="info"
            @click="
              $router.push({ name: 'student-scoring-component-entry-create' })
            "
            >{{ $t('add_new') }}</ts-button
          >
          <div class="d-flex">
            <ts-input
              v-model="search"
              :placeholder="$t('search')"
              style="width: 250px"
              class="inline-block"
            />
            <ts-button
              outline
              class="ml-2"
              v-tooltip="$t('filter')"
              @click.prevent="visible = true"
            >
              <i class="fa fa-filter"></i>
            </ts-button>
          </div>
        </div>
        <!-- drawer -->
        <a-drawer
          :title="$t('filter')"
          placement="right"
          :closable="false"
          :visible="visible"
          @close="() => (visible = false)"
          :zIndex="1020"
          width="300px"
        >
          <drawer-filter />
          <div class="row">
            <div class="col-md-12">
              <ts-button
                color="primary"
                class="mr-2"
                @click.prevent="fetchData"
                >{{ $t('view') }}</ts-button
              >
              <ts-button color="danger" @click.prevent="clearFilter">{{
                $t('studentScoringComponentEntry.clear')
              }}</ts-button>
            </div>
          </div>
        </a-drawer>
      </ts-card-wrapper>
      <!-- table list -->
      <div class="overflow-auto">
        <ts-table
          :columns="columns"
          :records="resources"
          :loading="loading"
          :expandable="true"
        >
          <template v-slot="{ record }">
            <td>
              {{ record.branch.branch_name_en }}
            </td>
            <td>{{ record.full_name_en }}</td>
            <td>
              {{
                record.score_student_scoring_comp_item_detail
                  ? record.score_student_scoring_comp_item_detail[0]
                      .scoring_cycle.scoring_cycle_name
                  : null
              }}
            </td>
            <td>
              {{
                record.score_student_scoring_comp_item_detail
                  ? record.score_student_scoring_comp_item_detail[0]
                      .academic_class.class_name
                  : null
              }}
            </td>
            <td>
              {{
                record.score_student_scoring_comp_item_detail
                  ? record.score_student_scoring_comp_item_detail[0]
                      .main_program.acp_name_foreign
                  : null
              }}
            </td>
            <td>
              {{
                record.score_student_scoring_comp_item_detail
                  ? record.score_student_scoring_comp_item_detail[0].ac_term
                      .term_name
                  : null
              }}
            </td>
            <td>
              {{
                record.score_student_scoring_comp_item_detail
                  ? record.score_student_scoring_comp_item_detail[0].ac_year
                      .ac_year
                  : null
              }}
            </td>
          </template>
          <div slot="expand" slot-scope="prop">
            <table class="ts-w-11/12 ts-mx-auto detail">
              <thead>
                <tr class="ts-uppercase ts-bg-gray-200 ts-h-8 ts-text-white">
                  <th class="ts-pl-2 ts-whitespace-nowrap">
                    {{ $t('studentScoringComponentEntry.subject') }}
                  </th>
                  <th class="ts-pl-2 ts-whitespace-nowrap">
                    {{ $t('studentScoringComponentEntry.subjectComponent') }}
                  </th>
                  <th class="ts-pl-2 ts-whitespace-nowrap">
                    {{ $t('studentScoringComponentEntry.subjectSubComponent') }}
                  </th>
                  <th class="ts-pl-2 ts-whitespace-nowrap ts-text-center">
                    {{ $t('studentScoringComponentEntry.actualScore') }}
                  </th>
                  <th class="ts-pl-2 ts-text-center ts-whitespace-nowrap">
                    {{ $t('actions') }}
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr
                  class="ts-border-b-2"
                  v-for="(detail, index) in prop.record
                    .score_student_scoring_comp_item_detail"
                  :key="index"
                >
                  <td class="ts-p-2 ts-whitespace-nowrap">
                    {{ detail.subject_name_foreign }}
                  </td>
                  <td class="ts-p-2 ts-whitespace-nowrap">
                    {{ detail.comp_item_name }}
                  </td>
                  <td class="ts-p-2 ts-whitespace-nowrap">
                    {{ detail.subject_comp_item_detail_name }}
                  </td>
                  <td class="ts-p-2 ts-whitespace-nowrap ts-text-center">
                    {{ detail.actual_score }}
                  </td>
                  <td class="ts-whitespace-no-wrap text-center">
                    <a
                      href="#"
                      class="mr-2 text-danger"
                      @click.prevent="deleteScore(detail)"
                    >
                      <i class="fas fa-trash"></i>
                    </a>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </ts-table>
      </div>
      <!-- numeric scoring entry -->
      <a-modal
        v-if="numeric_scoring"
        v-model="numeric_scoring"
        :zIndex="1020"
        :title="entry_on_student"
        :maskClosable="false"
        :footer="null"
        width="700px"
      >
        <numeric-scoring-entry
          v-model="model"
          @closeModal="() => (numeric_scoring = false)"
        />
      </a-modal>
      <!-- grading scoring entry -->
      <div class="d-flex justify-content-end p-15">
        <ts-pagination
          v-model="pagination"
          @navigate="fetchData"
        ></ts-pagination>
      </div>
    </ts-card>
  </div>
</template>

<script>
import { debounce } from 'lodash'
import { mapState } from 'vuex'
import DrawerFilter from './components/drawer-filter'
import NumericScoringEntry from './components/numeric-score-entry'

export default {
  name: 'studentScoringComponentEntry',
  components: {
    DrawerFilter,
    NumericScoringEntry,
  },
  data() {
    return {
      numeric_scoring: false,
      grading_scoring: false,
      entry_on_student: null,
      loading: false,
      visible: false,
      paramsGetComponentForGrading: {
        grade_id: 0,
        sc_bas_id: null,
      },
      model: {
        class_id: null, // add on param
        score_type: 1, // add on param but no use in DB
        st_class_id: null,
        acp_id: null,
        ac_year_id: null,
        ac_term_id: null,
        student_id: null,
        scoring_cycle_id: null,
        cycle_value: null,
        sc_subject_id: null,
      },
    }
  },
  created() {
    this.fetchData()
  },
  computed: {
    ...mapState('studentScoringComponentEntry', ['resources', 'pagination']),
    search: {
      get() {
        return this.$store.state.studentScoringComponentEntry.search
      },
      set(newValue) {
        this.$store.commit('studentScoringComponentEntry/SET_SEARCH', newValue)
        this.$store.commit('studentScoringComponentEntry/RESET_CURRENT_PAGE')
      },
    },
    columns() {
      return [
        { name: this.$t('studentScoringComponentEntry.branchName') },
        { name: this.$t('studentScoringComponentEntry.studentName') },
        { name: this.$t('studentScoringComponentEntry.scoringCycle') },
        { name: this.$t('studentScoringComponentEntry.className') },
        { name: this.$t('studentScoringComponentEntry.mainProgram') },
        { name: this.$t('studentScoringComponentEntry.academicTerm') },
        { name: this.$t('studentScoringComponentEntry.academicYear') },
      ]
    },
  },
  methods: {
    fetchData(attributes) {
      this.loading = true
      this.$store
        .dispatch('studentScoringComponentEntry/fetch', attributes)
        .then((response) => {
          this.loading = false
        })
        .catch((error) => {
          this.loading = false
          this.$toasted.error(error.message)
        })
    },
    clearFilter() {
      this.$store.commit('studentScoringComponentEntry/RESET_FILTER')
      this.fetchData()
    },
    async deleteScore(record) {
      if (await this.$confirmModal.danger(this.$t('are_you_sure_to_delete'))) {
        record._deleting = true
        this.$store
          .dispatch('studentScoringComponentEntry/destroy', record.scoring_id)
          .then((response) => {
            this.fetchData()
            this.$toasted.success(response.message)
            record._deleting = false
          })
          .catch((error) => {
            this.$toasted.error(error.message)
            record._deleting = false
          })
      }
    },
  },
  watch: {
    search: debounce(function (search) {
      this.fetchData({ branch_id: this.branch_id })
    }, 500),
  },
  beforeRouteLeave(to, from, next) {
    this.$store.commit('studentScoringComponentEntry/RESET_STATE')
    this.$store.commit('studentScoringComponentEntry/RESET_FILTER')
    next()
  },
}
</script>
